import { Block, Button, LogOut01, Mats, ParagraphSmall, useStyletron, } from "@mezo-org/mezo-clay";
import React, { useCallback } from "react";
import { useDisconnect } from "wagmi";
import { useSignOut } from "../../hooks";
import AccountAddress from "./AccountAddress";
import AccountAssets from "./AccountAssets";
import AccountBalance from "./AccountBalance";
import WelcomeBlock from "./WelcomeBlock";
function MatsnetLabel() {
    const [, theme] = useStyletron();
    return (React.createElement(ParagraphSmall, { color: theme.colors.contentTertiary },
        React.createElement(Mats, { color: "currentColor", size: theme.sizing.scale400, overrides: {
                Svg: {
                    style: {
                        marginRight: theme.sizing.scale300,
                    },
                },
            } }),
        "Matsnet Assets"));
}
export default function DropdownContent(props) {
    const { data, onSignOut } = props;
    const [, theme] = useStyletron();
    const { mezoId, address, walletType, totalBalanceInUsd, formattedNativeAssets, matsnet, } = data;
    const { disconnect } = useDisconnect();
    const { signOut } = useSignOut();
    const handleLogOut = useCallback(() => {
        if (onSignOut) {
            onSignOut();
            return;
        }
        signOut();
        disconnect();
    }, [signOut, disconnect, onSignOut]);
    return (React.createElement(Block, { display: "inline-flex", flexDirection: "column", backgroundColor: theme.colors.backgroundPrimary, padding: theme.sizing.scale500, width: "100%", overrides: {
            Block: {
                style: {
                    boxSizing: "border-box",
                },
            },
        } },
        React.createElement(WelcomeBlock, { mezoId: mezoId, matsBalance: matsnet.mats }),
        React.createElement(Block, { display: "flex", flexDirection: "column", backgroundColor: theme.colors.backgroundSecondary, overflow: "hidden", overrides: {
                Block: { style: { borderRadius: theme.borders.radius300 } },
            } },
            React.createElement(AccountAddress, { address: address, type: walletType }),
            React.createElement(AccountBalance, { amount: totalBalanceInUsd }),
            React.createElement(AccountAssets, { label: "Assets", assets: formattedNativeAssets })),
        matsnet.formattedAssets.length > 0 && (React.createElement(Block, { marginTop: theme.sizing.scale600, backgroundColor: theme.colors.backgroundSecondary, overflow: "hidden", overrides: {
                Block: { style: { borderRadius: theme.borders.radius300 } },
            } },
            React.createElement(AccountAssets, { label: React.createElement(MatsnetLabel, null), assets: matsnet.formattedAssets }))),
        React.createElement(Block, { marginTop: theme.sizing.scale700, padding: `0 ${theme.sizing.scale100}` },
            React.createElement(Button, { size: "small", kind: "tertiary", startEnhancer: React.createElement(LogOut01, { color: "currentColor", size: 12 }), onClick: () => handleLogOut(), overrides: {
                    Root: {
                        style: {
                            ":hover": {
                                backgroundColor: theme.colors.backgroundSecondary,
                                boxShadow: "none",
                            },
                            ":active": {
                                backgroundColor: theme.colors.backgroundSecondary,
                                color: theme.colors.contentPrimary,
                            },
                        },
                    },
                } }, "Log out"))));
}
//# sourceMappingURL=Content.js.map